import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function WhatsAppButton() {
  const [number, setNumber] = useState("5511999999999");
  useEffect(() => {
    api.get("/settings").then((r) => setNumber(r.data?.whatsapp_number || "5511999999999"));
  }, []);
  const href = `https://wa.me/${number.replace(/\D/g, "")}?text=${encodeURIComponent(
    "Olá! Vim pela loja ActiveMode e gostaria de uma informação."
  )}`;
  return (
    <a
      data-testid="whatsapp-float-btn"
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-label="Conversar no WhatsApp"
      className="fixed bottom-6 right-6 z-40 h-14 w-14 rounded-full bg-[#25D366] text-black grid place-items-center shadow-[0_8px_30px_rgba(37,211,102,0.4)] hover:scale-110 transition-transform duration-300"
    >
      <svg width="26" height="26" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
        <path d="M20.52 3.48A11.86 11.86 0 0012.04 0C5.42 0 .07 5.35.07 11.96c0 2.11.55 4.17 1.6 5.98L0 24l6.26-1.64a11.96 11.96 0 005.78 1.47h.01c6.62 0 11.97-5.35 11.97-11.96 0-3.2-1.24-6.2-3.5-8.39zM12.05 21.3h-.01a9.9 9.9 0 01-5.04-1.38l-.36-.21-3.72.97.99-3.63-.23-.37A9.9 9.9 0 012.14 11.96c0-5.47 4.45-9.91 9.92-9.91 2.65 0 5.14 1.03 7.02 2.91a9.86 9.86 0 012.9 7.01c-.01 5.47-4.45 9.92-9.93 9.92zm5.44-7.42c-.3-.15-1.77-.87-2.04-.97-.27-.1-.47-.15-.67.15s-.77.97-.95 1.17c-.17.2-.35.22-.65.07-.3-.15-1.26-.47-2.4-1.49-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.14-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.03-.52-.07-.15-.67-1.63-.92-2.23-.24-.58-.49-.5-.67-.51-.17-.01-.37-.01-.57-.01-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.22 3.08c.15.2 2.11 3.22 5.1 4.51.71.31 1.27.49 1.7.63.72.23 1.37.2 1.89.12.58-.09 1.77-.72 2.02-1.42.25-.7.25-1.3.17-1.42-.07-.12-.27-.2-.57-.35z" />
      </svg>
    </a>
  );
}
